export const SIGN_UP = 'SIGN_UP';

export const ACCEPT_COWORKER_INVITATION = 'ACCEPT_COWORKER_INVITATION';
export const ACCEPT_COWORKER_INVITATION_SUCCESS =
  'ACCEPT_COWORKER_INVITATION_SUCCESS';
export const ACCEPT_COWORKER_INVITATION_FAILURE =
  'ACCEPT_COWORKER_INVITATION_FAILURE';
export const acceptCoworkerInvitation = data => ({
  type: ACCEPT_COWORKER_INVITATION,
  payload: { ...data, tokenFormat: 'jwt' }
});

export const CREATE_PHONE_CODE_SIGNUP = 'CREATE_PHONE_CODE_SIGNUP';
export const CREATE_PHONE_CODE_SIGNUP_SUCCESS =
  'CREATE_PHONE_CODE_SIGNUP_SUCCESS';
export const CREATE_PHONE_CODE_SIGNUP_FAILURE =
  'CREATE_PHONE_CODE_SIGNUP_FAILURE';

export const createPhoneCode = data => ({
  type: CREATE_PHONE_CODE_SIGNUP,
  payload: { ...data, loginType: 'phone' }
});

export const CREATE_CUSTOMER = 'CREATE_CUSTOMER';
export const CREATE_CUSTOMER_FAILURE = 'CREATE_CUSTOMER_FAILURE';
export const CREATE_CUSTOMER_SUCCESS = 'CREATE_CUSTOMER_SUCCESS';

export const createCustomer = customerInformations => ({
  type: CREATE_CUSTOMER,
  payload: { ...customerInformations, tokenFormat: 'jwt' }
});

export const RESET_STORE = 'RESET_STORE';
export const resetStore = () => ({ type: RESET_STORE });
